/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_LegalInputs */

const de_auth_mfa_error_legal = /** @type {(inputs: Auth_Mfa_Error_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugang aus rechtlichen Gründen eingeschränkt.`)
};

/** @type {(inputs: Auth_Mfa_Error_LegalInputs) => LocalizedString} */
const en_auth_mfa_error_legal = de_auth_mfa_error_legal;

/**

* @param {Auth_Mfa_Error_LegalInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_legal = /** @type {((inputs?: Auth_Mfa_Error_LegalInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_LegalInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_legal(inputs)
	return en_auth_mfa_error_legal(inputs)
});